export const PRESET = "preset";
export const CUSTOM = "custom";
export const UNTITLED_ROLE = "Untitled role";
export const supportUserRoleId = "YcZKjDZJHHUAl9yPCBmy";
